import { render, staticRenderFns } from "./UnlockMedicamentForm.vue?vue&type=template&id=1ef5bcf0"
import script from "./UnlockMedicamentForm.vue?vue&type=script&lang=js"
export * from "./UnlockMedicamentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports